import { Component, ComponentChild, h } from 'preact'
import Icon, { IconType } from '../assets'

import axios, { AxiosError, AxiosResponse } from 'axios'

type Status = 'waiting'|'success'|'error'

interface SyncState {
  status: Status,
  date: string,
  error: string | null
}

interface Props {
}

interface State {
  status: SyncState | null
}

type StatusIconMap = Record<Status, IconType>

const stateToIconMapping: StatusIconMap = {
  'waiting': 'spinner',
  'success': 'check',
  'error': 'close'
}

const statusMessage = (status: Status, error: string|null) => {
  if (status === 'waiting') {
    return 'Syncing in progress...'
  }

  if (status === 'success') {
    return 'Last synced at '
  }

  return `${error} `
}

interface SyncDateProps {
  date: string
}

const options = { month: 'short', day: 'numeric', year: 'numeric', hour12: false, hour: 'numeric', minute: '2-digit' }
const SyncDate = ({ date }: SyncDateProps) => {
  const formattedDate = new Date(date).toLocaleDateString('en-US', options)

  return (<span>{formattedDate}</span>)
}

class ZendeskTicketSyncStatus extends Component<Props, State> {
  private timeout: number
  private keepPolling: boolean

  constructor (props: Props) {
    super(props)

    this.timeout = 0
    this.keepPolling = true
    this.setState({ status: null })

    this.fetchStatus = this.fetchStatus.bind(this)
    this.handleResponse = this.handleResponse.bind(this)
  }

  componentDidMount () {
    this.fetchStatus()
  }

  private handleResponse ({ data }: AxiosResponse<SyncState>): void {
    const keepPolling = this.keepPolling && data.status !== 'error'

    if (keepPolling) {
      this.timeout = setTimeout(this.fetchStatus, 30 * 1000)
    }

    this.keepPolling = keepPolling
    this.setState({ status: data })
  }

  private handleError ({ response }: AxiosError): void {
    this.keepPolling = response && response.status >= 500 || false

    this.setState({ status: null })
  }

  fetchStatus (): void {
    clearTimeout(this.timeout)

    axios.get<SyncState>('/integration/zendesk/fetchSyncTicketStatus')
        .then(this.handleResponse)
        .catch(this.handleError)
  }

  render (props: Props, { status }: State): ComponentChild {
    if (!status) {
      return null
    }

    return (
      <div className='integrations-zendesk__ticket-sync-status'>
        { this.getMessageForStatus(status) }
      </div>
    )
  }

  getMessageForStatus ({ status, date, error }: SyncState): ComponentChild {
    const isWaiting = (status === 'waiting')
    const isError = (status === 'error')
    const customClass = (isWaiting) ? 'icon-spinning-animation' : ''

    return (<span>
      <span className='integrations-zendesk__ticket-sync-status-icon'>
        { status && <Icon icon={stateToIconMapping[status]} customClass={customClass} width={18} height={18} /> }
      </span>
      <p>
        { statusMessage(status, error) }
        { isError && '(Failed at '}
        { status !== 'waiting' && <SyncDate date={date} /> }
        { isError && ')' }
      </p>
    </span>)
  }
}

export default ZendeskTicketSyncStatus
